import React from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';

import * as API from '../../utils/api'

import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import gesd_logo from '../../assets/logos/gesd_logo_stacked.svg'
import pw_icon from '../../assets/Login/pw_icon.svg'
import user_icon from '../../assets/Login/user_icon.svg'

import './index.css';

import {PUBLIC_URL} from "../../utils/api";

import {useAuth} from "../../lib/auth";


export default function LoginView(){

    const {login} = useAuth()
    const history = useHistory()

    const forgetPassword = (e) =>{
        e.preventDefault();
        window.alert("Please find the helpDesk to help you reset the password");
    }

    const onLoginSuccess = () => {
        history.push('/')
    }

    const onLoginError = (error) => {
        window.alert(error.response.data.detail);
    }

    const sumbit = (e) => {
        e.preventDefault();
        const username = e.target.username.value;
        const password = e.target.password.value;
        if(!username && !password){
            window.alert("The username and password can not be blank");
            return;
        }
        else if(!username){
            window.alert("The username can not be blank");
            return;
        }
        else if(!password){
            window.alert("The password can not be blank");
            return;
        }

        //call the api
        var body = {
            username: username,
            password: password,
            remember_me: e.target.customcb1.checked,
        }

        login(body, onLoginSuccess, onLoginError)
    }

    const ssoLogin = (e) =>{
        const LandingUrl = `${PUBLIC_URL}/landing`;
        const failLandUrl = `${PUBLIC_URL}/failLand`;
        window.location.href = `${API.SSO_URL}?key=${API.SSO_KEY}&successUrl=${LandingUrl}&failureUrl=${failLandUrl}`;
    }

    return (
        <div className="container-fluid">
            <div className="row login-container">
                <div className="col-md-5 py-5 d-flex flex-column align-items-center justify-content-center login-gradient">
                    <div className="text-end">
                        <p className="leftBackText">Regional Digital Control Centre</p>
                        <img src={gesd_logo} alt="logo" className="mb-3 logo-size"/>
                    </div>
                </div>
                <div className="col-md-7 text-center d-flex flex-column py-5 justify-content-center">
                    <form 
                        className="rightInputDiv"
                        id="main-login"
                        onSubmit={sumbit}
                    >
                        <InputGroup className="mb-3 border rounded">
                            <Button disabled={true} variant="outline-secondary" id="button-addon1" className="border-0">
                                <img src={user_icon} className="rightInputIcon" alt="logo" />
                            </Button>
                            <FormControl
                                id="username"
                                className="border-0"
                                placeholder="Username"
                                aria-label="username"
                                aria-describedby="basic-addon1"
                            />
                        </InputGroup>
                        <InputGroup className="mb-3 border rounded">
                            <Button disabled={true} variant="outline-secondary" id="button-addon1" className="border-0">
                                <img src={pw_icon} className="rightInputIcon" alt="logo" />
                            </Button>
                            <FormControl
                                id="password"
                                className="border-0"
                                type="password"
                                placeholder="Password"
                                aria-label="password"
                                aria-describedby="basic-addon1"
                            />
                        </InputGroup>
                        <div className="d-md-flex justify-content-between mb-3">
                            <div className="red customcb">
                                <input type="checkbox" value="true" id="customcb1" name="" />
                                <label className="inner" htmlFor="customcb1"></label>
                                <label className="outer" htmlFor="customcb1">Remember me</label>
                            </div> 

                            <Link to='' onClick={forgetPassword} className="text-secondary">
                                Forget Password?
                            </Link>
                        </div>
                        <div className="d-grid gap-2">
                            <input type="submit" value="Login" className="btn btn-success btn-block border-0 mb-3 login-btn" />
                        </div>
                        <div className="d-grid gap-2">
                            <Button onClick={ssoLogin} className="btn btn-success btn-block border-0 mb-3 sso-btn" >
                                <img src={`${process.env.PUBLIC_URL}/ccep_sso_logo.png`} className="sso-logo"/>Log in with CCeP Portal
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

